/* eslint-disable */
const awsmobile = {
  aws_project_region: "eu-west-1",
  aws_cognito_region: "eu-west-1",
  aws_user_pools_id: "",
  aws_user_pools_web_client_id: "",
  cookieStorage: {
    // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    domain: ".delaval.cloud",
    // OPTIONAL - Cookie path
    path: "/",
    // OPTIONAL - Cookie expiration in days
    expires: 365,
    // OPTIONAL - Cookie secure flag
    // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    secure: true,
  },
  oauth: {
    //Empties is handeled by env variabled with Vue CLI
    domain: "",
    scope: ["openid"],
    redirectSignIn: "",
    redirectSignOut: "",
    responseType: "token",
  },
};
export default awsmobile;
